var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"float-right mb-1",attrs:{"small":"","elevation":"2","color":" primary","text":""},on:{"click":_vm.fnExportChartJsToPng}},[_c('v-icon',{attrs:{"sm":"","color":""}},[_vm._v("mdi-download")]),_vm._v(" (PNG)")],1),_c('canvas',{attrs:{"id":"grafica-usuarios"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }